function injectStyle (ssrContext) {
  require("!!../../../../../develop/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader!../../../../../develop/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-1062a6bc\",\"scoped\":false,\"hasInlineConfig\":false}!stylus-loader?{\"sourceMap\":true}!../../../../../develop/node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue")
  require("!!vue-style-loader!css-loader?minimize!../../../../../develop/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-1062a6bc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../develop/node_modules/vue-loader/lib/selector?type=styles&index=1!./App.vue")
}
var Component = require("!../../../../../develop/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../develop/node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue"),
  /* template */
  require("!!../../../../../develop/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1062a6bc\",\"hasScoped\":true}!../../../../../develop/node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1062a6bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/App.vue
// module id = 216
// module chunks = 0